import React, { useEffect, useState } from "react";
import AllDropDownsAHSF from "../../../../Components/AllDropDownsAHSF";
import { useDispatch, useSelector } from "react-redux";
import { GetActionByFlowId } from "../../../../Redux/Reducers/Manager/Dropdowns/GetActionByFlowId";
import { GetAllFlow } from "../../../../Redux/Reducers/Manager/Dropdowns/GetAllFlow";
import { GetAllRoundActive } from "../../../../Redux/Reducers/Manager/Dropdowns/GetAllRoundActive";
import {
  GetAllFieldsByRoundManager,
  GetAllFieldsManagerForReportStage,
} from "../../../../Redux/Reducers/Manager/Dropdowns/GetAllFieldByRound";
import { SetArrayDataCheckBoks } from "../../../../Redux/Reducers/Shared/CheckBox";

function TransferRequestsStatusDropDowns(props) {
  const dispatch = useDispatch();
  const [DropDownRoundActive, setDropDownRoundActive] = useState("");
  const [DropDownFields, setDropDownFields] = useState("");
  const [DropDownFlow, setDropDownFlow] = useState("");
  const [DropDownActionByFlowId, setDropDownActionByFlowId] = useState("");

  const state = useSelector((state) => {
    return {
      DropDownRoundActive: state.DropDownRoundActive.DropDownRoundActive,
      DropDownFieldsManager: state.DropDownFieldsManager.DropDownFieldsManager,
      DropDownFlow: state.DropDownFlow.DropDownFlow,
      DropDownActionByFlowId:
        state.DropDownActionByFlowId.DropDownActionByFlowId,
      DropDownGetAllFieldsManagerForReportStage:
        state.DropDownFieldsManager.DropDownGetAllFieldsManagerForReportStage,
    };
  });

  useEffect(() => {
    dispatch(GetAllRoundActive());
  }, []);

  useEffect(() => {
    if (DropDownRoundActive && window.location.href.includes("report")) {
      dispatch(
        GetAllFieldsManagerForReportStage({
          sU_ST_MRI_RoundYearId: parseInt(DropDownRoundActive),
        })
      );
    }
  }, [DropDownRoundActive]);

  useEffect(() => {
    if (DropDownRoundActive ) {
      dispatch(
        GetAllFieldsByRoundManager({
          sU_ST_MRI_RoundYearId: parseInt(DropDownRoundActive),
        })
      );
    }
  }, [DropDownRoundActive]);

  useEffect(() => {
    dispatch(GetAllFlow());
  }, []);

  useEffect(() => {
    if (DropDownFlow) {
      dispatch(
        GetActionByFlowId({
          flowId: DropDownFlow,
        })
      );
      console.log(DropDownFlow, "flowwww");
    }
  }, [DropDownFlow]);

  console.log(DropDownFlow, "flow");
  console.log(DropDownRoundActive, "round");

  return (
    <>
      <div className="form-grid">
        <AllDropDownsAHSF
          fieldsName="Round"
          show={true}
          arrayOoptionList={state.DropDownRoundActive}
          KeyText={"roundName"}
          KeyValue={"sU_ST_MRI_RoundYearId"}
          dropdownType={"normal"}
          onChange={(e) => {
            setDropDownRoundActive(e.target.value);
            props.setRoundActive(e.target.value);
            dispatch(SetArrayDataCheckBoks());
          }}
        />
        <AllDropDownsAHSF
          fieldsName="FieldManager"
          show={true}
          arrayOoptionList={
            window.location.href.includes("report")
              ? state.DropDownGetAllFieldsManagerForReportStage
              : window.location.href.includes("manager")
              ? state.DropDownFieldsManager
              : ""
          }
          KeyText={"fieldName"}
          KeyValue={"fieldId"}
          dropdownType={"normal"}
          onChange={(e) => {
            setDropDownFields(e.target.value);
            props.setFields(e.target.value);
            dispatch(SetArrayDataCheckBoks());
          }}
        />
        {!props.manager && (
          <>
            <AllDropDownsAHSF
              fieldsName="CurrentStatusName"
              show={true}
              arrayOoptionList={state.DropDownFlow}
              KeyText={"flowName"}
              KeyValue={"flowId"}
              dropdownType={"normal"}
              onChange={(e) => {
                setDropDownFlow(e.target.value);
                props.setFlow(e.target.value);
                dispatch(SetArrayDataCheckBoks());
              }}
            />
            <AllDropDownsAHSF
              fieldsName="Action"
              show={true}
              arrayOoptionList={state.DropDownActionByFlowId}
              KeyText={"actionName"}
              KeyValue={"actionId"}
              dropdownType={"normal"}
              onChange={(e) => {
                setDropDownActionByFlowId(e.target.value);
                props.seActionId(e.target.value);
                // dispatch(SetArrayDataCheckBoks())
              }}
            />
          </>
        )}
      </div>
    </>
  );
}

export default TransferRequestsStatusDropDowns;
